import React from "react";
import { Box } from "@mui/material";
import Visits from "./Visits"; // Adjust the path if necessary

const ViolationVisitsTab = ({ violation_id, currentUserId }) => {
  return (
    <Box>
      <Visits
        violation_id={violation_id}
        currentUserId={currentUserId}
      />
    </Box>
  );
};

export default ViolationVisitsTab;
